import { GFInitialState } from "./models/models";

export const migrations: {[key: number]: (state: GFInitialState)=>GFInitialState } = {
    174: state => {
        return {...state, shouldLogout: false}
    }
}